// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const ordersData = createApi({
  reducerPath: "ordersApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    orderHistory: builder.query({
      query: (student_id) => ({
        url: `order_history`,
        params: { student_id },
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
    rating: builder.mutation({
      query: (body) => ({
        url: `add_review`,
        method: "POST",
        body,
      }),

      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useRatingMutation, useOrderHistoryQuery } = ordersData;
